import * as React from "react";
import { FormFieldContainer } from "../modals/modal-form-elements";
import { Checkbox } from "./checkbox";
import { CompanySpotlights } from "../../constants/company-info";

export const SPOTLIGHTS_HELP_TEXT =
  "Optional. Select any that describe your founders or company. They are shown on your company page " +
  "and used by the Pitch Planet Spotlight filter.";

/**
 * The optional Spotlight checkboxes of the company forms.
 */
export const SpotlightsField = ({ value, onChange }: { value: string[]; onChange: (value: string[]) => void }) => {
  const selected = Array.isArray(value) ? value : [];
  // ... keep a saved value that is no longer offered, so it can still be unticked
  const options = [...CompanySpotlights, ...selected.filter((item) => !CompanySpotlights.includes(item))];

  const toggle = (spotlight: string) => () => {
    onChange(selected.includes(spotlight) ? selected.filter((item) => item !== spotlight) : [...selected, spotlight]);
  };

  return (
    <FormFieldContainer>
      <label htmlFor="spotlights">
        <span>Spotlight:</span>
      </label>
      <p className="spotlights-help-text">{SPOTLIGHTS_HELP_TEXT}</p>
      <div className="spotlights-field" id="spotlights">
        {options.map((spotlight) => (
          <Checkbox
            key={`spotlight-${spotlight}`}
            checked={selected.includes(spotlight)}
            onChange={toggle(spotlight)}
            label={spotlight}
          />
        ))}
      </div>
    </FormFieldContainer>
  );
};
